import { render } from "./CRM.vue?vue&type=template&id=3c5dabb8&scoped=true&ts=true&lang=pug"
import script from "./CRM.vue?vue&type=script&lang=ts"
export * from "./CRM.vue?vue&type=script&lang=ts"

import "./CRM.vue?vue&type=style&index=0&id=3c5dabb8&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3c5dabb8"]])

export default __exports__